import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { HOLIDAY_MANAGE_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const holidayServiceApi = createApi({
  reducerPath: "holidayEmployeeApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: HOLIDAY_MANAGE_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
  tagTypes: ["GetHolidays", "GetHolidaysByDate", "GetHolidayDetails"],
});
